var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "SBP-wrapper" },
    [
      _c("sec-title"),
      _vm._v(" "),
      _vm.loadingToken ? _c("loading", { staticClass: "loading" }) : _vm._e(),
      _vm._v(" "),
      !_vm.loadingToken
        ? _c(
            "div",
            { staticClass: "section" },
            [
              _c("div", { staticClass: "__second-title" }, [
                _vm._v(_vm._s(_vm.$t("walletSBP.section1.title")))
              ]),
              _vm._v(" "),
              _c("register", { attrs: { canUseAddr: _vm.canUseAddr } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.loadingToken
        ? _c(
            "div",
            { staticClass: "section" },
            [
              _c("div", { staticClass: "__second-title" }, [
                _vm._v(_vm._s(_vm.$t("walletSBP.section2.title")))
              ]),
              _vm._v(" "),
              _c("list", { attrs: { showConfirm: _vm.showConfirm } })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showConfirmType
        ? _c(
            "confirm",
            {
              staticClass: "middle",
              attrs: {
                showMask: true,
                title: _vm.$t(
                  "walletSBP.confirm." + _vm.showConfirmType + ".title"
                ),
                singleBtn: true,
                closeIcon: true,
                close: _vm.closeConfirm,
                leftBtnTxt: _vm.$t(
                  "walletSBP.confirm." + _vm.showConfirmType + ".btn"
                ),
                leftBtnClick: _vm.validTx,
                btnUnuse: !!_vm.btnUnuse
              }
            },
            [
              _vm.showConfirmType === "edit"
                ? _c(
                    "div",
                    [
                      _c(
                        "tabs",
                        {
                          staticClass: "sbp-edit-tabs",
                          on: { change: _vm.tabChange }
                        },
                        [
                          _c(
                            "tab",
                            {
                              key: "1",
                              attrs: {
                                name: _vm.$t(
                                  "walletSBP.confirm.edit.changeBlockProducer"
                                ),
                                selected: true
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.addrErr,
                                      expression: "addrErr"
                                    }
                                  ],
                                  staticClass: "input-err"
                                },
                                [_vm._v(_vm._s(_vm.addrErr))]
                              ),
                              _vm._v(" "),
                              _c("vite-input", {
                                attrs: {
                                  valid: _vm.testAddr,
                                  placeholder: _vm.$t(
                                    "walletSBP.confirm." +
                                      _vm.showConfirmType +
                                      ".changeBlockProducer"
                                  )
                                },
                                model: {
                                  value: _vm.blockProducerAddress,
                                  callback: function($$v) {
                                    _vm.blockProducerAddress = $$v
                                  },
                                  expression: "blockProducerAddress"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "tab",
                            {
                              key: "2",
                              attrs: {
                                name: _vm.$t(
                                  "walletSBP.confirm.edit.changeRewardAddress"
                                )
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.addrErr,
                                      expression: "addrErr"
                                    }
                                  ],
                                  staticClass: "input-err"
                                },
                                [_vm._v(_vm._s(_vm.addrErr))]
                              ),
                              _vm._v(" "),
                              _c("vite-input", {
                                attrs: {
                                  valid: _vm.testAddr,
                                  placeholder: _vm.$t(
                                    "walletSBP.confirm." +
                                      _vm.showConfirmType +
                                      ".changeRewardAddress"
                                  )
                                },
                                model: {
                                  value: _vm.rewardAddress,
                                  callback: function($$v) {
                                    _vm.rewardAddress = $$v
                                  },
                                  expression: "rewardAddress"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }